export const ErrorGraphics = () => {
  return (
    <svg width="109" height="110" viewBox="0 0 109 110" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="108" height="108" fill="white" fillOpacity="0.01" />
      <rect
        x="34.3553"
        y="8.70923"
        width="68.8912"
        height="82.6694"
        rx="3.44456"
        transform="rotate(10 34.3553 8.70923)"
        fill="#DC2626"
      />
      <rect
        x="27.6323"
        y="8"
        width="68.8912"
        height="82.6694"
        rx="3.44456"
        transform="rotate(5 27.6323 8)"
        fill="#991B1B"
      />
      <rect
        x="20.4542"
        y="8.08911"
        width="68.8912"
        height="82.6694"
        rx="3.44456"
        fill="white"
        stroke="#E2E8F0"
        strokeWidth="1.16985"
        strokeLinecap="square"
      />
      <svg xmlns="http://www.w3.org/2000/svg" x="40" y="35" width="30" height="30" viewBox="0 0 30 30" fill="none">
        <path
          d="M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z"
          stroke="#DC2626"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 11.25L11.25 18.75"
          stroke="#DC2626"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 11.25L18.75 18.75"
          stroke="#DC2626"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  )
}
